export default __webpack_public_path__ + "static/media/download_pdf.9d25158a.svg";